<div class="forgotten-password-title" style="background-color: #ededed;">
  @if (_data.whichStep ) {
    <p class="reset-pwd-title">{{'common.text_Saved_Billing_Addresses'|
    cxTranslate}}</p>
  } @else {
    <p class="reset-pwd-title">{{'common.text_Saved_Shipping_Addresses'| cxTranslate}}</p>
  }
  <button class="dialog-close-btn" aria-label="close dialog" mat-dialog-close>
    <img src="/icons/close-light-grey.svg" alt="" [ngClass]="!isMobile ?'close':'mob-close'" width="25" />
  </button>
</div>
<div class="search-address">
  <input type="text" placeholder="{{'common.text_Type_here_to_search_address'|cxTranslate}}" name="searchInput"
    [(ngModel)]="searchInput" />
  </div>
  <mat-dialog-content>
    <div>
      <ul>
        @for (result of _data.address | filter: searchInput; track result) {
          <li
            [ngClass]="!isMobile ?'addList':'mob-addList'">
            <div [ngClass]="!isMobile ?'col-6' :''">
              @if (result?.sapCustomerID) {
                <span class="description">{{ result?.sapCustomerID }}</span>
                }<br>
                <span class="description">{{result?.companyName}}</span><br>
                <span class="description">{{result?.line1}}</span><br>
                <span class="description">{{result?.postalCode}},&nbsp;{{result?.town}}</span><br>
                <span class="description">{{result?.country?.name}}</span>
              </div>
              <div [ngClass]="!isMobile ? 'col-6' : ''">
                <button type="submit" class="btn btn-block address-btn" (click)="updateAddress(result)">
                  {{ 'common.checkout_multi_deliveryAddress_useThisAddress' | cxTranslate }}
                  <img src="/icons/link-dark-grey.svg" class="icon-right" alt="">
                </button>
              </div>
            </li>
          }
        </ul>
      </div>
    </mat-dialog-content>